import * as ng from 'angular';
import * as _ from 'underscore';
import * as uib from 'angular-ui-bootstrap';

import {GuestType, GuestTypeService} from '../../../guest-type';

const urlGenerateViewUrl = require('./url-generate-view.html');

ng.module('e360')
   .factory('showUrlGenerateModal', showUrlGenerateModalFactory);

showUrlGenerateModalFactory.$inject = ['$uibModal'];
function showUrlGenerateModalFactory($uibModal:uib.IModalService) {
   return showUrlGenerateModal;

   /**
    * Shows the Url Generation Modal popup.
    * @param {bool} guestTypeInUrl A boolean to disable the guesttype dropdown if not
    * wanted.
    * @param {string} domain The domain of the site
    * @param {boolean} isRSVP A boolean indicating if the site is rsvp or not. This is
    * necessary as the two sites don't have the same url structure and we need to
    * differentiate.
    */
   function showUrlGenerateModal(guestTypeInUrl:boolean, domain:string, isRSVP:boolean) {
      $uibModal.open({
         size: 'md',
         backdrop: 'static',
         templateUrl: urlGenerateViewUrl,
         controller: 'URLGenerateController',
         controllerAs: 'vm',
         keyboard: false,
         resolve: {
            allowGuestTypeInURL: () => guestTypeInUrl,
            domain: () => domain,
            isRSVP: () => isRSVP
         }
      });
   }
}

export class URLGenerateController implements ng.IController {
   static $inject: string[] = [
      '$q',
      '$uibModalInstance',
      'session',
      'utils',
      'GuestTypeService',
      'eventsApi',
      'l10n',
      'allowGuestTypeInURL',
      'domain',
      'isRSVP'
   ];

   guestTypes: GuestType[];
   events: any[];
   timeSlots: any[];
   languages: string[];

   isBusy = false;
   url: string;

   selectedEvent: any;
   selectedGuestType: GuestType;
   selectedTimeSlot: any;
   selectedLanguage: any;

   constructor (
      private $q: ng.IQService,
      private $uibModalInstance,
      private session,
      private utils,
      private guestTypeService: GuestTypeService,
      private eventsApi,
      private l10n,
      private allowGuestTypeInURL:boolean,
      private domain:string,
      private isRSVP:boolean
   ) {
      let campaignId = this.session.getCampaign().id;
      let params = { campaignId: campaignId };

      let promises = [
         this.guestTypeService.list(campaignId),
         eventsApi.list(params)
      ];

      //Dummy objects to act as null option for dropdowns
      let nullEvent = {
         name: '-- No Event --'
      };

      let nullGuestType = {
         id: null,
         campaignId: null,
         name: 'General',
         slug: null,
         settings: null
      };

      this.languages = this.session.getCampaign().settings.languages;
      this.selectedLanguage = this.session.getCampaign().defaultLanguage;

      this.isBusy = true;
      $q.all(promises).then((data: any[]) => {
         this.guestTypes = data[0];

         //filter by active and future events
         this.events = _.filter(data[1].list, (event) => {
            return new Date(event.endDateTime) > new Date();
         });

         this.guestTypes.unshift(nullGuestType);
         this.events.unshift(nullEvent);

         this.selectedGuestType = this.guestTypes[0];
         this.selectedEvent = this.events[0];
         this.generateURL();
      }).finally(() => {
         this.isBusy = false;
      });
   }

   eventChanged () {
      if (this.session.getCampaign().hasTimeSlots) {
         this.isBusy = true;
         this.timeSlots = null;
         this.eventsApi.get(this.selectedEvent.id).then((e) => {
            //TODO: this should cache timeslot in events to avoid too many calls to the backend
            this.timeSlots = e.timeSlots;

            //Dummy object to act as null option for dropdown
            let nullTimeSlot = {
               name: '-- No Time Slot --'
            };

            this.timeSlots.unshift(nullTimeSlot);
            this.selectedTimeSlot = this.timeSlots[0];
         }).finally(() => {
            this.isBusy = false;
         });
      } else {
         this.generateURL();
      }
   }

   generateURL () {
      this.url = `https://${this.domain}/`;

      let eventId:string = null;
      let guestTypeSlug:string = this.selectedGuestType ? this.selectedGuestType.slug : null;

      if (this.selectedEvent &&
         this.selectedEvent.id &&
         !this.session.getCampaign().hasTimeSlots) {
         eventId = this.selectedEvent.id;
      } else if (this.selectedTimeSlot && this.selectedTimeSlot.id) {
         eventId = this.selectedTimeSlot.id;
      }

      // Structuring the urls like this was necessary as the RSVP site and the
      // Self reg site don't conform to the same url structure. In the future,
      // if the RSVP site is changed to match the self reg site then this could
      // be changed to something like token replacement.
      if (this.isRSVP) {
         // RSVP urls are structured like:
         // no event selected: https://domain.co/?lang=en
         // event selected: https://domain.co/event/12345?lang=en
         if (eventId) {
            this.url += `event/${eventId}`;
         }

         this.url += `?lang=${this.selectedLanguage}`;

         if (guestTypeSlug) {
            this.url += `&guestType=${guestTypeSlug}`;
         }
      } else {
         // Self Reg urls are structured like:
         // no event selected: https://domain.co/en/events
         // event selected: https://domain.co/en/events/12345/register/1
         this.url += `${this.selectedLanguage}/events`;
         if (eventId) {
            this.url += `/${eventId}/register/1`;
         }

         if (guestTypeSlug) {
            this.url += `?guestType=${guestTypeSlug}`;
         }
      }
   }

   done () {
      this.$uibModalInstance.dismiss('cancel');
   }

   //copy/paste from importer. need to centralize this
   getTimeSlotLabel(timeSlot: any): string {
      if (!timeSlot)
         return '';

      let label = '';
      if (timeSlot.name) {
         label += timeSlot.name + ' ';
      }
      label += this.utils.formatDate(timeSlot.startDateTime, 'M/D/YYYY - h:mma');
      return label;
   }
}

ng.module('e360')
   .controller('URLGenerateController', URLGenerateController);
